import { Button } from "components/common/button/Button";
import { useAtom } from "jotai"
import { useTranslation } from "react-i18next";
import { stepAtom } from "store/signUpStore";
import './SignUpStep4.css'
import { TermCheckBox } from "components/common/termCheckBox/TermCheckBox";
import { useState } from "react";
import { Device } from "common/device";

export const SignUpStep4 = () => {
    const {t} = useTranslation();
    const [step, setStep] = useAtom(stepAtom);

    const [term6Checked, setTerm6Checked] = useState(false);
    const [term7Checked, setTerm7Checked] = useState(false);


    return (
        <div className="sign-up-step-4" style={{display: step === 4 ? "block" : "none"}}>
            <span className="title">{t("signUp.needTermAgreeTitle")}</span>
            <span className="info">{t("signUp.needTermAgreeInfo")}</span>

            <div style={{display: "flex", flexDirection: "column", marginTop: "50px"}}>
                <TermCheckBox
                    title={t("signUp.term6")} id="term_6"
                    checked={term6Checked}
                    setChecked={setTerm6Checked}
                    isRequired
                />
                <TermCheckBox
                    title={t("signUp.term7")} id="term_7"
                    checked={term7Checked}
                    setChecked={setTerm7Checked}
                    isRequired
                />
            </div>

            <div style={{position: 'fixed', bottom: Device.inset.navigationBarHeight, width: '100%', left: 0, padding: "0 20px 20px"}}>
                <Button
                    text={t("signUp.btnTermsCom")}
                    onPress={() => {setStep(5)}}
                    disabled={!term6Checked || !term7Checked}
                />
            </div>
        </div>
    )
}